// extracted by mini-css-extract-plugin
export default {"background":"Hero_background__nZOGe","hero":"Hero_hero__BX3b8","hero__content":"Hero_hero__content__0Ru8X"};